import { Bell, ListTodo, Radar, User, Crown } from 'lucide-react'

export default function SoloView() {
  return (
    <div className="space-y-6">
      <h2 className="text-xs font-bold tracking-widest text-gray-500 uppercase">Solo Command Center</h2>
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        {/* The Briefing */}
        <div className="panel lg:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <Bell className="w-4 h-4 text-aith-accent" />
            <h3 className="text-sm font-bold text-white">The Briefing</h3>
            <span className="ml-auto text-[10px] text-aith-green bg-aith-green/10 px-2 py-0.5 rounded">3 new</span>
          </div>
          <div className="space-y-2">
            <div className="p-3 bg-gray-800/50 rounded border-l-2 border-aith-green text-xs">
              <p className="text-gray-300">Stomach stack deployed successfully. LobeHub, Ollama, Portainer running.</p>
              <p className="text-[10px] text-gray-600 mt-1">2 minutes ago</p>
            </div>
            <div className="p-3 bg-gray-800/50 rounded border-l-2 border-aith-yellow text-xs">
              <p className="text-gray-300">Nextcloud AIO requires attention — container name mismatch resolved.</p>
              <p className="text-[10px] text-gray-600 mt-1">15 minutes ago</p>
            </div>
            <div className="p-3 bg-gray-800/50 rounded border-l-2 border-gray-600 text-xs">
              <p className="text-gray-300">Tailscale mesh: 6 live machines detected. 44 ghost entries need cleanup.</p>
              <p className="text-[10px] text-gray-600 mt-1">20 minutes ago</p>
            </div>
          </div>
        </div>

        {/* The Radar */}
        <div className="panel">
          <div className="flex items-center gap-2 mb-4">
            <Radar className="w-4 h-4 text-aith-cyan" />
            <h3 className="text-sm font-bold text-white">The Radar</h3>
          </div>
          <div className="space-y-3 text-xs">
            <div className="flex justify-between items-center">
              <span className="text-gray-400">Active Agents</span>
              <span className="text-aith-green font-mono">0/7</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-gray-400">Running Containers</span>
              <span className="text-aith-green font-mono">3/4</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-gray-400">Cloudflare Workers</span>
              <span className="text-aith-green font-mono">1 LIVE</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-gray-400">DO Inference Credits</span>
              <span className="text-aith-yellow font-mono">$205.00</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-gray-400">Tailscale Nodes</span>
              <span className="text-aith-green font-mono">6 live</span>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {/* The Queue */}
        <div className="panel">
          <div className="flex items-center gap-2 mb-4">
            <ListTodo className="w-4 h-4 text-aith-purple" />
            <h3 className="text-sm font-bold text-white">The Queue</h3>
          </div>
          <div className="space-y-2 text-xs">
            <div className="flex items-center gap-3 p-2 rounded hover:bg-gray-800/50 cursor-pointer">
              <input type="checkbox" className="accent-aith-accent" />
              <span className="text-gray-300">Fix Nextcloud AIO restart loop</span>
              <span className="ml-auto text-[10px] text-aith-red border border-aith-red/30 px-1.5 rounded">HIGH</span>
            </div>
            <div className="flex items-center gap-3 p-2 rounded hover:bg-gray-800/50 cursor-pointer">
              <input type="checkbox" className="accent-aith-accent" />
              <span className="text-gray-300">Deploy Falcon cockpit to Cloudflare Pages</span>
              <span className="ml-auto text-[10px] text-aith-yellow border border-aith-yellow/30 px-1.5 rounded">MED</span>
            </div>
            <div className="flex items-center gap-3 p-2 rounded hover:bg-gray-800/50 cursor-pointer">
              <input type="checkbox" className="accent-aith-accent" />
              <span className="text-gray-300">Clean Tailscale ghost entries (44 stale nodes)</span>
              <span className="ml-auto text-[10px] text-gray-500 border border-gray-700 px-1.5 rounded">LOW</span>
            </div>
            <div className="flex items-center gap-3 p-2 rounded hover:bg-gray-800/50 cursor-pointer">
              <input type="checkbox" className="accent-aith-accent" checked readOnly />
              <span className="text-gray-500 line-through">Install Docker on Stomach droplet</span>
              <span className="ml-auto text-[10px] text-aith-green">DONE</span>
            </div>
            <div className="flex items-center gap-3 p-2 rounded hover:bg-gray-800/50 cursor-pointer">
              <input type="checkbox" className="accent-aith-accent" checked readOnly />
              <span className="text-gray-500 line-through">Connect Stomach to Tailscale mesh</span>
              <span className="ml-auto text-[10px] text-aith-green">DONE</span>
            </div>
          </div>
        </div>

        {/* The Throne Room */}
        <div className="panel">
          <div className="flex items-center gap-2 mb-4">
            <Crown className="w-4 h-4 text-aith-yellow" />
            <h3 className="text-sm font-bold text-white">The Throne Room</h3>
          </div>
          <div className="space-y-4">
            <div className="flex items-center gap-3 p-3 bg-gray-800/30 rounded">
              <div className="w-10 h-10 rounded-full bg-aith-accent/20 flex items-center justify-center text-aith-accent">
                <User className="w-5 h-5" />
              </div>
              <div>
                <p className="text-sm font-semibold text-white">Solo (bsvongsrisart)</p>
                <p className="text-[10px] text-gray-500">Founder, AiTH-Solutions</p>
              </div>
              <span className="ml-auto text-[10px] bg-aith-green/10 text-aith-green px-2 py-1 rounded">Online</span>
            </div>
            <div className="text-xs space-y-2 text-gray-400">
              <p><span className="text-gray-300">Active Machine:</span> MacBook Air (100.97.90.37)</p>
              <p><span className="text-gray-300">Session Started:</span> Jun 8, 2026 03:43 UTC+7</p>
              <p><span className="text-gray-300">Pillars Online:</span> 3/10</p>
              <p><span className="text-gray-300">Next Milestone:</span> $100/day revenue</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
